<section class="circuit-diagram-shell" *ngIf="tagNumber$ | async as tagNumber">
  <div class="circuit-diagram-shell__placeholder" *ngIf="circuitsLoading$ | async">Loading circuit diagram...</div>

  <div class="circuit-diagram-shell__boards" *ngIf="(currentCircuitTag$ | async) === tagNumber && !(circuitsLoading$ | async)">
    <div class="circuit-diagram-shell__controls">
      <button type="button" (click)="toggleMinified()">{{ isMinified ? 'Expand labels' : 'Minify labels' }}</button>
      <button type="button" (click)="zoomOut()" [disabled]="focusedPath.length === 0">Zoom out</button>
      <button type="button" (click)="zoomToRoot()" [disabled]="focusedPath.length === 0">Root</button>
      <span class="circuit-diagram-shell__breadcrumb" *ngIf="focusedPath.length > 0">Focus: {{ breadcrumb() }}</span>
    </div>

    <ng-container *ngIf="circuits$ | async as boards">
      <div class="circuit-diagram-shell__board" *ngFor="let db of boards" [hidden]="!isBoardVisible(db)">
        <ng-container *ngIf="focusedRootJbox(db) as rootJbox; else maybeDistributionBoardRoot">
          <a
            *ngIf="cpMcpRoute(rootJbox) as rootJboxRoute; else rootJboxLabel"
            class="circuit-diagram-shell__root-jbox"
            [class.circuit-diagram-shell__root-jbox--minified]="isMinified"
            [routerLink]="rootJboxRoute"
            [queryParams]="tagQueryParams(rootJbox.no)"
            aria-label="Focused junction box element"
          >
            {{ displayLabel(rootJbox.no) }}
            <ng-container *ngIf="rootJbox.checkSheetStatuses?.length; else rootJboxDefaultStatus">
              <div class="circuit-diagram-shell__status-indicators">
                <app-check-sheet-status
                  *ngFor="let checkSheetStatus of rootJbox.checkSheetStatuses"
                  class="circuit-diagram-shell__status-indicator"
                  [status]="checkSheetStatus.status?.name"
                  [label]="checkSheetStatus.name"
                />
              </div>
            </ng-container>
            <ng-template #rootJboxDefaultStatus>
              <div class="circuit-diagram-shell__status-indicators">
                <app-status-circle class="circuit-diagram-shell__status-indicator circuit-diagram-shell__status-indicator--default" [status]="rootJbox.status?.name" />
              </div>
            </ng-template>
          </a>
          <ng-template #rootJboxLabel>
            <div class="circuit-diagram-shell__root-jbox circuit-diagram-shell__root-jbox--static" [class.circuit-diagram-shell__root-jbox--minified]="isMinified">
              {{ displayLabel(rootJbox.no) }}
              <ng-container *ngIf="rootJbox.checkSheetStatuses?.length; else rootJboxStaticDefaultStatus">
                <div class="circuit-diagram-shell__status-indicators">
                  <app-check-sheet-status
                    *ngFor="let checkSheetStatus of rootJbox.checkSheetStatuses"
                    class="circuit-diagram-shell__status-indicator"
                    [status]="checkSheetStatus.status?.name"
                    [label]="checkSheetStatus.name"
                  />
                </div>
              </ng-container>
              <ng-template #rootJboxStaticDefaultStatus>
                <div class="circuit-diagram-shell__status-indicators">
                  <app-status-circle class="circuit-diagram-shell__status-indicator circuit-diagram-shell__status-indicator--default" [status]="rootJbox.status?.name" />
                </div>
              </ng-template>
            </div>
          </ng-template>
         </ng-container>

         <ng-template #maybeDistributionBoardRoot>
           <div *ngIf="shouldShowDistributionBoardRoot(db)" class="circuit-diagram-shell__board-root">
            <a
              *ngIf="cpMcpRoute(db) as dbRoute; else dbLabel"
              class="circuit-diagram-shell__board-container"
              [class.circuit-diagram-shell__board-container--minified]="isMinified"
              [routerLink]="dbRoute"
              [queryParams]="tagQueryParams(db.no)"
              aria-label="Distribution board element"
            >
              <div class="circuit-diagram-shell__board-name">{{ displayLabel(db.no) }}</div>
              <ng-container *ngIf="db.checkSheetStatuses?.length; else dbDefaultStatus">
                <div class="circuit-diagram-shell__status-indicators">
                  <app-check-sheet-status
                    *ngFor="let checkSheetStatus of db.checkSheetStatuses"
                    class="circuit-diagram-shell__status-indicator"
                    [status]="checkSheetStatus.status?.name"
                    [label]="checkSheetStatus.name"
                  />
                </div>
              </ng-container>
              <ng-template #dbDefaultStatus>
                <div class="circuit-diagram-shell__status-indicators">
                  <app-status-circle class="circuit-diagram-shell__status-indicator circuit-diagram-shell__status-indicator--default" [status]="db.status?.name" />
                </div>
              </ng-template>
            </a>
            <ng-template #dbLabel>
              <div class="circuit-diagram-shell__board-container circuit-diagram-shell__board-container--static" [class.circuit-diagram-shell__board-container--minified]="isMinified">
                <div class="circuit-diagram-shell__board-name">{{ displayLabel(db.no) }}</div>
                <ng-container *ngIf="db.checkSheetStatuses?.length; else dbStaticDefaultStatus">
                  <div class="circuit-diagram-shell__status-indicators">
                    <app-check-sheet-status
                      *ngFor="let checkSheetStatus of db.checkSheetStatuses"
                      class="circuit-diagram-shell__status-indicator"
                      [status]="checkSheetStatus.status?.name"
                      [label]="checkSheetStatus.name"
                    />
                  </div>
                </ng-container>
                <ng-template #dbStaticDefaultStatus>
                  <div class="circuit-diagram-shell__status-indicators">
                    <app-status-circle class="circuit-diagram-shell__status-indicator circuit-diagram-shell__status-indicator--default" [status]="db.status?.name" />
                  </div>
                </ng-template>
              </div>
            </ng-template>

             <button
               *ngIf="boards.length > 1"
               type="button"
               class="circuit-diagram-shell__focus-button"
               (click)="focusOnDistributionBoard(db.no, $event)"
               aria-label="Focus distribution board"
             >
               <span aria-hidden="true">⌕</span>
             </button>
           </div>
         </ng-template>

         <div class="circuit-diagram-shell__circuits">
           <app-circuit-table
             *ngFor="let circuit of visibleCircuits(db)"
             [circuit]="circuit"
             [showCubicleName]="!isFocusedJboxRoot(db)"
             [pathPrefix]="pathPrefix(db)"
             [focusPath]="focusedPath"
             [isMinified]="isMinified"
             (focusRequested)="onFocusRequested($event)"
           ></app-circuit-table>
         </div>
       </div>
     </ng-container>
   </div>
</section>
